import React, {Fragment, useState, useEffect} from "react";
import PropTypes from "prop-types";
import {useStaticQuery, graphql , Link} from 'gatsby';
import Img from "gatsby-image";
import Scrollspy from 'react-scrollspy';
import CartNav from './cartnav'
import { CircleSpinner } from "react-spinners-kit";
import { prefetchOfferingsImages, prefetchOfferingsImagesOnIdle } from "../../utils/prefetchOfferingsImages";

// Start Header Area
const HeaderNoSidebar = (props) => {
    const headerQuerySidebar = useStaticQuery(graphql`
        query headerQuerySidebarQuery {
            allMenuJson {
                nodes {
                    title
                    path
                }
            },
            file(relativePath: {eq: "images/logo/logo.png"}) {
                childImageSharp {
                    fixed (quality: 100, width: 70, height: 35) {
                        ...GatsbyImageSharpFixed
                    }
                }
            }
        }
    `);

    const [isOverlayOpen, setOverlay] = useState(false);
    // let {
    //   cart,
    //   onUpdateCartQty,
    //   onRemoveFromCart,
    //   onEmptyCart,
    //   isCartVisible,
    //   setCartVisible,
    //   isOverlayOpen,
    //   setOverlay
    // } = props



    useEffect(() => {
        if(!isOverlayOpen){
          document.querySelector('.trigger-popup-menu').classList.remove('overlay-wrapper-open');
          document.querySelector('.hambergur-menu').classList.remove('hambergur-menu-open');
        }
    });

    const onMenuToggleClick = () => {
        setOverlay(prevState => !prevState)
        document.querySelector('.trigger-popup-menu').classList.toggle('overlay-wrapper-open');
        document.querySelector('.hambergur-menu').classList.toggle('hambergur-menu-open');
    };

    const [scroll, setScroll] = useState(false)
    useEffect(() => {
        window.addEventListener("scroll", () => {
        setScroll(window.scrollY > 10)
        })
    }, []);

        useEffect(() => {
            prefetchOfferingsImagesOnIdle();
        }, []);

    const waxonLogo = headerQuerySidebar.file.childImageSharp.fixed;

    return (
        <Fragment>
            <header className={scroll ? "rn-header header-default header-transparent d-block d-xl-none scrolled" : "rn-header header-default header-transparent d-block d-xl-none"}>
                <div className="header-inner">
                    {/* Header Logo  */}
                    <div className="header-left">
                        <div className="logo">
                            <Link to="/">
                                <Img fixed={waxonLogo}  />
                            </Link>
                        </div>
                    </div>
                    {/* Main Menu  */}
                    <div className="header-right" onClick={onMenuToggleClick}>
                        <div className="hambergur-menu">
                            <div className="hamburger-box">
                                <div className="hamburger-inner">

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Start Social Area  */}
                </div>
            </header>
            <div className="trigger-popup-menu">
                <div className="menu_full">
                    <div className="menu_wrapper">
                        <Scrollspy className="popup_mainmenu" items={['home','about', 'work-with-me' , 'readings' , 'contact']} currentClassName="is-current" offset={-200}>
                            <li>
                                <a className="menu-hover-link" href="/#home" onClick={onMenuToggleClick}>
                                    <span className="hover-item">
                                        <span data-text="Home">Home</span>
                                    </span>
                                </a>
                            </li>

                            <li>
                                <a className="menu-hover-link" href="/#about" onClick={onMenuToggleClick}>
                                    <span className="hover-item">
                                        <span data-text="About">About</span>
                                    </span>
                                </a>
                            </li>

                            <li>
                                <a className="menu-hover-link" href="/#work-with-me" onClick={onMenuToggleClick}>
                                    <span className="hover-item">
                                        <span data-text="Work With Me">Work With Me</span>
                                    </span>
                                </a>
                            </li>

                            <li>
                                <a className="menu-hover-link" href="/#news" onClick={onMenuToggleClick}>
                                    <span className="hover-item">
                                        <span data-text="Readings">Readings</span>
                                    </span>
                                </a>
                            </li>

                            <li>
                                <a
                                  className="menu-hover-link"
                                  href="/shop/offerings"
                                  onMouseEnter={() => prefetchOfferingsImages()}
                                  onFocus={() => prefetchOfferingsImages()}
                                  onTouchStart={() => prefetchOfferingsImages()}
                                  onClick={onMenuToggleClick}
                                >
                                    <span className="hover-item">
                                        <span data-text="Offerings">Offerings</span>
                                    </span>
                                </a>
                            </li>

                            <li>
                                <a className="menu-hover-link" href="/#contact" onClick={onMenuToggleClick}>
                                    <span className="hover-item">
                                        <span data-text="Contact">Contact</span>
                                    </span>
                                </a>
                            </li>
                            <li>
                            {/**cart && Object.entries(cart).length == 0 ?
                              <CircleSpinner size={30} loading={true} />
                              :
                              <CartNav
                                cart={cart}
                                onUpdateCartQty={onUpdateCartQty}
                                onRemoveFromCart={onRemoveFromCart}
                                onEmptyCart={onEmptyCart}
                                scroll={scroll}
                                isCartVisible={isCartVisible}
                                setCartVisible={setCartVisible}
                                isOverlayOpen={isOverlayOpen}
                                setOverlay={setOverlay}
                                />
                              */}
                            </li>
                        </Scrollspy>
                    </div>
                    <div className="trigger_closer" onClick={onMenuToggleClick}>
                        <span className="text">Close</span>
                        <span className="icon"></span>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
// End Header Area

HeaderNoSidebar.propTypes = {
  siteTitle: PropTypes.string,
}

HeaderNoSidebar.defaultProps = {
  siteTitle: ``,
}

export default HeaderNoSidebar;
